import _sfc_main from "./Button.vue2.mjs";
/* empty css             */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("button", { class: _setup.buttonClassList, style: _vm.customStyle, on: { "click": _setup.handleClick } }, [_vm.$slots.icon ? _c("span", { staticClass: "button-icon" }, [_vm._t("icon")], 2) : _vm._e(), _vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "76556122"
);
const TuiButton = __component__.exports;
export {
  TuiButton as default
};
